module.exports = function getResource(label, vars = []) {
    const resources = {
        chooseDeliveryFreq: 'Choose Delivery Frequency:',
        every: 'Every',
        mostCommon: 'Most Common',
        youWillSave: 'you will save',
        annualyWithSubs: 'annually with this subscription.',
        save: 'Save',
        cancel: 'Cancel',
        frequencyNumber: 'Frequency Number',
        frequencyType: 'Frequency Type',
        item: 'ITEM',
        actualPrice: 'Actual Price',
        originalPrice: 'Original Price'
    };

    return resources[label];
};
